import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { DetailedIconUnlock } from '@zillow/constellation';
import { Box, Heading, Image, Modal, Paragraph, TextButton } from '@zillow/constellation-10';
import { ZillowInsuranceServicesLogo } from '@zillow/zrs-comet';

import propertyUtils from '../../../utils/propertyUtils';

import ModalFooter from '../ModalFooter';
import ChecklistDiamond from '../../../images/ChecklistDiamond.png';

import { ExpandableDisclaimer } from '@zillow/zrs-comet';

const propTypes = { onClose: PropTypes.func.isRequired };
const defaultProps = {};

const RentGuaranteeActiveModal = ({ legalDisclaimer, coverageSummaryUrl, coverageAmount, onClose, onSubmit }) => {
  const { currentProperty } = useSelector((state) => state.properties);

  const { formattedAddress } = propertyUtils.formatAddress(currentProperty);

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<ZillowInsuranceServicesLogo />}
      body={
        <Box css={{ padding: { base: '200', md: '1200' } }}>
          <Box css={{ display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: '200' }}>
            <DetailedIconUnlock size="md" />
            <Heading level={4} fontFamily="serif">
              Your Rental Protection coverage is effective
            </Heading>
          </Box>
          <Box css={{ marginInline: '200' }}>
            <Paragraph css={{ marginBottom: '400' }}>
              {`LeaseLock has confirmed that Rental Protection is in effect for ${formattedAddress}.`}
            </Paragraph>
            <Box
              css={{
                display: 'flex',
                padding: '400',
                marginBottom: '400',
                backgroundColor: 'bg.accent.teal.soft',
                width: '100%',
              }}
            >
              <Box>
                <Image className="ChecklistDiamond" src={ChecklistDiamond} alt="checklist" />
              </Box>
              <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                <Paragraph textStyle="body-bold">What&apos;s covered?</Paragraph>
                <Paragraph css={{ marginBottom: '400' }}>
                  Rental Protection provides up to {coverageAmount} of insurance coverage to help with some of the
                  situations your other insurance policies don&apos;t cover, like when tenants don&apos;t pay their
                  rent, or their puppy chews your unit&apos;s new carpet.
                </Paragraph>
                <TextButton asChild>
                  <a target="_blank" rel="noopener noreferrer" href={coverageSummaryUrl}>
                    See the coverage summary
                  </a>
                </TextButton>
              </Box>
            </Box>
            {legalDisclaimer && (
              <ExpandableDisclaimer title="Coverage disclaimer" disclaimerContent={[legalDisclaimer]} />
            )}
          </Box>
        </Box>
      }
      footer={<ModalFooter submitText="OK" onSubmit={onSubmit} />}
      size={{ base: 'fullScreen', md: 'md' }}
    />
  );
};

RentGuaranteeActiveModal.propTypes = propTypes;
RentGuaranteeActiveModal.defaultProps = defaultProps;

export default RentGuaranteeActiveModal;
